import { autorun } from 'mobx';
import { observer } from 'mobx-react';
import { GENERIC_SIGN_IN_ERROR, useRootStore } from '@nandosaus/state-management';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { Alert } from '../alert';
import { MFAForm } from '../mfa-form';
import { SignIn } from './sign-in';
import { UpdateDetailsForm } from '../update-details-form';

const SignInForm = ({ showAlert, headingText, landingPage, hideCreateAccountLink, noXPadding, isCheckout }) => {
  const [error, setError] = useState();
  const [mfa, setMfa] = useState({});
  const { AuthStore, CartStore, MemberStore } = useRootStore();
  const { profile } = MemberStore;
  useEffect(() => {
    const disposer = autorun(() => {
      const { error: err } = MemberStore;
      if (err) {
        // MemberStore.error is internal copy ("There was an error fetching profile", or a raw
        // upstream string) written for logs, not for customers. Sign-in has still failed from
        // where they are standing, so the form shows the approved catch-all instead.
        setError(GENERIC_SIGN_IN_ERROR);
      }
    });
    return () => disposer();
  }, [AuthStore, MemberStore]);

  if (mfa.user) {
    return (
      <>
        <MFAForm error={error} mfa={mfa} />
        {CartStore.isDineIn && (
          <Alert heading="Having trouble placing an order?" type="info" mt="16px">
            No problem, head to the front counter and we&apos;ll put your order through
          </Alert>
        )}
      </>
    );
  }

  if (!profile) {
    return (
      <SignIn
        showAlert={showAlert}
        error={error}
        setError={setError}
        setMfa={setMfa}
        signIn={AuthStore.signIn}
        headingText={headingText}
        landingPage={landingPage}
        hideCreateAccountLink={hideCreateAccountLink}
        noXPadding={noXPadding}
        isCheckout={isCheckout}
      />
    );
  }

  if (!profile.mobile) {
    return <UpdateDetailsForm />;
  }

  return null;
};

SignInForm.propTypes = {
  showAlert: PropTypes.bool,
  hideCreateAccountLink: PropTypes.bool,
  headingText: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  landingPage: PropTypes.string,
  noXPadding: PropTypes.bool,
  isCheckout: PropTypes.bool,
};

SignInForm.defaultProps = {
  showAlert: false,
  headingText: undefined,
  landingPage: null,
  hideCreateAccountLink: false,
  noXPadding: false,
  isCheckout: false,
};

const ComposedSignInForm = observer(SignInForm);
export { ComposedSignInForm as SignInForm };
